import { MapPin, ZoomIn, ZoomOut, Layers } from "lucide-react";
import { Button } from "../ui/button";

const MapPlaceholder = () => {
  // Sample meter locations for visualization
  const meterPoints = [
    { x: 20, y: 30 },
    { x: 35, y: 25 },
    { x: 50, y: 35 },
    { x: 65, y: 20 },
    { x: 80, y: 40 },
    { x: 25, y: 55 },
    { x: 45, y: 60 },
    { x: 70, y: 55 },
    { x: 30, y: 75 },
    { x: 55, y: 80 },
    { x: 75, y: 70 },
    { x: 40, y: 45 },
  ];

  return (
    <div className="relative h-[300px] bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-border overflow-hidden">
      {/* Grid pattern background */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `
            linear-gradient(to right, hsl(var(--border)) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(var(--border)) 1px, transparent 1px)
          `,
          backgroundSize: "40px 40px",
        }}
      />

      {/* Simulated map area with meter markers */}
      <div className="absolute inset-4">
        {meterPoints.map((point, index) => (
          <div
            key={index}
            className="absolute transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer"
            style={{ left: `${point.x}%`, top: `${point.y}%` }}
          >
            <div className="relative">
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse-soft" />
              <div className="absolute inset-0 w-3 h-3 bg-primary/30 rounded-full animate-ping" />
            </div>
          </div>
        ))}
      </div>

      {/* Map Controls */}
      <div className="absolute right-3 bottom-3 flex flex-col gap-1">
        <Button
          variant="secondary"
          size="icon"
          className="w-8 h-8 bg-card shadow-sm"
        >
          <ZoomIn className="w-4 h-4" />
        </Button>
        <Button
          variant="secondary"
          size="icon"
          className="w-8 h-8 bg-card shadow-sm"
        >
          <ZoomOut className="w-4 h-4" />
        </Button>
        <Button
          variant="secondary"
          size="icon"
          className="w-8 h-8 bg-card shadow-sm"
        >
          <Layers className="w-4 h-4" />
        </Button>
      </div>

      {/* Location indicator */}
      <div className="absolute left-3 top-3 flex items-center gap-2 bg-card/90 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-sm">
        <MapPin className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-foreground">
          Service Area
        </span>
      </div>
    </div>
  );
};

export default MapPlaceholder;
